import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-language-menu',
  templateUrl: './language-menu.component.html',
  styleUrls: ['./language-menu.component.scss']
})
export class LanguageMenuComponent extends UserpilotReloader implements OnInit, OnDestroy {
  currentLanguage?: string;
  onDestroyNotifier = new EventEmitter();
  showMenu = false;
  allLanguages: { display: string, value: string }[] = [
    {display: 'english', value: 'en'},
    {display: 'français', value: 'fr'},
    {display: 'deutsch', value: 'de'},
    {display: 'italiano', value: 'it'},
    {display: 'español', value: 'es'},
    {display: 'party mode', value: 'yi'},
  ];
  supportedLanguages: { display: string, value: string }[] = [];

  constructor(private translationService: AnessaTranslationService) {
    super();
  }

  ngOnInit(): void {
    this.translationService.translationReadyNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(loaded => {
        if (loaded) {
          this.currentLanguage = this.translationService.getCurrentLang();
        }
      });
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.currentLanguage = this.translationService.getCurrentLang();
      });

    this.filterLanguages();
    this.translationService.availableLanguagesChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.filterLanguages();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  filterLanguages() {
    const availableLanguages = this.translationService.getAvailableLanguages();
    this.supportedLanguages = this.allLanguages.filter(lang => availableLanguages.includes(lang.value));
  }

  /**
   * Sets the showMenu variable and resets the new alert flag.
   * @param val
   */
  toggleMenu(val: boolean) {
    this.showMenu = val;
  }

  onLanguageSelect(language: string) {
    this.translationService.changeLanguage(language);
  }
}
